<div class="main-container">
  <p class="font-14 navy-blue-color">{{isAcura ? 'AcuraLink' : 'HondaLink'}} Subscription</p>

  <div class="feature-box-section black-color">

    <!--
    There are 6 conditions to consider in header
     1- There is only 30days trial (so show no buttons)
     2- theres is 30Days trial with paid upcoming package available (show each Current/Upcoming and changeSusbcription button below upcoming package only)
     3- theres is paid package running with one another paid package available as upcoming (show each Current/Upcoming and changeSusbcription button below upcoming package only)
     4- theres is a paid package but it has been cancelled and no upcoming package available (show Susbcribe btn)
     5- theres is a paid package but it has been Expired and no upcoming package available (show Susbcribe btn)
     6- theres is a paid package but it needs to renewed within 90Days (show Renew btn)

     To check if its a trial we use: currentPlanDuration == 'Trial'         // Trial|Monthly|Annual
     To check if an upcoming is available we use: upcomingPackageAvailable  // true|false


     there are 3 sub sections in this header
     - trial only
     - trail and upcoming + running and upcoming
     - running and options for cancel, re-subscribe and re-new
    -->
    <!-- <pre>
      Current PLan status: {{currentPlanStatus}} //Active //Cancel //Expired
      current Plan expired {{currentPlanExpired}} // true/false
      current Plan renewable {{currentPlanRenewable}} // true/false 90days limit active
      upcoming pkg avail {{upcomingPackageAvailable}} // true/false
      current pkg duration {{currentPlanDuration}}  // Trial/ 3 Year/ 5 Year
    </pre> -->

    <!--first sub section  -->

    <div
      *ngIf="currentPlanStatus === 'Active' && (currentPlanDuration == 'Trial'|| currentPlanDuration == '5 Year' || currentPlanDuration == '3 Year') &&  !upcomingPackageAvailable && subscriptionTypeGdo=='gdo'">
      <div class="gdo-subscription-detail-header-subSection pb-2">
        <p class="font-18 text-center-align black-color font-weight-400">myQ Connected Garage</p>
        <p class="font-18 text-center-align black-color font-weight-400"> {{ currentPlanInfo.planName }} <span
            *ngIf="currentPlanDuration != 'Trial'"> ({{ currentPlanRatePerUnit | currency }})</span></p>
        <p class="font-14 text-center-align black-color font-weight-400"> Expires on: {{ currentPlanInfo.endDate | date:
          'MM/dd/yyyy' }}</p>
        <!-- remove this div once testing for flow is completed before production -->
        <div *ngIf="currentPlanDuration=='Trial'" class="change-subs-fecture-btns flex justify-content-center">
          <button class="edit-form-button standard-btn danger-btn btn-width" mat-flat-button
            (click)="onChangeSubscriptionClick()">Purchase Subscription</button>
        </div>
        <!--  -->
      </div>
    </div>

    <!-- second subsection:This section will handle both cases where is current is trial or a paid annual_OR_monthly plan-->
    <div
      *ngIf="currentPlanStatus === 'Active' &&  (currentPlanDuration == 'Trial'|| currentPlanDuration == '5 Year' || currentPlanDuration == '3 Year') && upcomingPackageAvailable && subscriptionTypeGdo=='gdo'">

      <!-- top section -->
      <div class="gdo-subscription-detail-header-subSection section-seperator-with-bm-10">
        <span class="font-18 pl-20 black-color font-weight-400">Current</span>
        <p class="font-18 text-center-align black-color font-weight-400">myQ Connected Garage</p>
        <p class="font-18 text-center-align black-color font-weight-400"> {{ currentPlanInfo.planName }} <span
            *ngIf="currentPlanDuration != 'Trial'"> ({{ currentPlanRatePerUnit | currency }})</span></p>
        <p class="font-14 text-center-align black-color font-weight-400"> Expires on: {{ currentPlanInfo.endDate | date:
          'MM/dd/yyyy' }}</p>
      </div>

      <!-- bottom section -->
      <div class="gdo-subscription-detail-header-subSection">
        <span class="font-18 pl-20 black-color font-weight-400">Upcoming</span>
        <p class="font-18 text-center-align black-color font-weight-400">myQ Connected Garage</p>
        <p class="font-18 text-center-align black-color font-weight-400"> {{ upcomingPlanInfo.planName }} ({{
          upcomingPlanRatePerUnit | currency}})</p>
        <p class="font-14 text-center-align black-color font-weight-400"> Starts on:
          {{ startDateForUI }}
        </p>       
        <!-- <div class="change-subs-fecture-btns flex justify-content-center">
        <button class="edit-form-button standard-btn danger-btn btn-width" mat-flat-button (click)="onChangeSubscriptionClick()">Change Subscription</button>
      </div> -->
        <p class="noticeText font-12 text-center-align font-weight-400">If you cancel your subscription, no refund will
          be provided.</p>
      </div>
    </div>


    <!-- TODO:check for trial condition why its rendering this if we add trial condition -->
    <!--third subsection :this section contains all three use cases for cancel renew and expire-->

    <div *ngIf="currentPlanStatus !== 'Active' && !upcomingPackageAvailable  && subscriptionTypeGdo =='gdo'">

      <!-- top section -->
      <div class="gdo-subscription-detail-header-subSection pb-2">
        <p class="font-18 text-center-align black-color font-weight-400">myQ Connected Garage</p>
        <p class="font-18 text-center-align black-color font-weight-400"> {{ currentPlanInfo.planName }}
          <span *ngIf="currentPlanDuration !== 'Trial'">({{ currentPlanRatePerUnit | currency }})</span>
        </p>
      </div>


      <!-- If current plan is expired -->
      <div *ngIf="currentPlanExpired && !currentPlanRenewable && currentPlanStatus === 'Expired'">
        <p class="font-14 text-center-align black-color font-weight-400"> Expired on : {{ currentPlanInfo.endDate |
          date: 'MM/dd/yyyy'}}</p>
        <div class="change-subs-fecture-btns flex justify-content-center">
          <button class="edit-form-button standard-btn danger-btn btn-width" mat-flat-button
            (click)="onChangeSubscriptionClick()" allowCancelOrChangeSubscription>Subscribe</button>
        </div>
      </div>

      <!-- If current plan is cancelled -->
      <div *ngIf="currentPlanStatus == 'Cancelled'|| currentPlanStatus == 'Terminated'">
        <p *ngIf="currentPlanStatus == 'Cancelled'" class="font-14 text-center-align black-color font-weight-400">
          Cancelled on {{ currentPlanStatusDate | date: 'MM/dd/yyyy' }}</p>
        <p *ngIf="currentPlanStatus == 'Terminated'" class="font-14 text-center-align black-color font-weight-400">
          Expired on {{ currentPlanStatusDate | date: 'MM/dd/yyyy' }}</p>
        <div class="change-subs-fecture-btns flex justify-content-center">
          <button class="edit-form-button standard-btn danger-btn btn-width" mat-flat-button
            (click)="onChangeSubscriptionClick()" [disabled]="stolenStatus"
            allowCancelOrChangeSubscription>Subscribe</button>
        </div>
      </div>


      <!-- If current plan is renewable -->
      <div
        *ngIf="!currentPlanExpired && currentPlanRenewable && (currentPlanStatus != 'Cancelled' || currentPlanStatus !== 'Terminated')">
        <p class="font-14 text-center-align black-color font-weight-400"> Expires on: {{ currentPlanInfo.endDate | date:
          'MM/dd/yyyy' }}</p>
        <div class="change-subs-fecture-btns flex justify-content-center">
          <button class="edit-form-button standard-btn danger-btn btn-width" mat-flat-button
            (click)="onChangeSubscriptionClick()">Renew</button>
        </div>
        <p class="noticeText font-12 text-center-align font-weight-400">
          Your subscription expires in {{leftDaysForRenewable}} days.Renew to continue having access.
        </p>
      </div>
    </div>


    <!-- Features Section start-->

    <!-- Billing -->
    <div class="container-detail">
      <div>
        <p class="font-14 black-color font-weight-500 padding-top-10">
          Billing History
        </p>
      </div>
      <button mat-flat-button (click)="onViewBillingHistoryClick()" class="button" [disabled]="stolenStatus">
        View
      </button>
    </div>
    <div class="row">
      <p class="font-14 black-color font-weight-400 ">
        Last Billed On: {{ (!currentPlanExpired && currentPlanDuration !== 'Trial') ? currentPlanInfo.lastBillDate
        :'N/A' }}
      </p>
    </div>

    <!-- Payment Method -->
    <div class="container-detail">
      <div>
        <p class="font-14 black-color font-weight-500 padding-top-10">
          Payment Method
        </p>
        <div>
          <p id="p3" class="font-14 grey-color font-weight-400 zero-padding">
            {{paymentMethodInfo && paymentMethodInfo.suffix ? paymentMethodInfo.ccType + ' **** **** ****' +
            paymentMethodInfo.suffix :'' }}
          </p>
          <p id="p4" class="font-14 grey-color font-weight-400 zero-padding">
            Billing Address: {{billingAddress ? billingAddress : 'Not configured'}}
          </p>
        </div>
        <!-- <div>
          <p id="p3" class="font-14 grey-color font-weight-400 zero-padding">
            Visa **** **** **** {{paymentMethodInfo?.suffix}}
          </p>
          <p id="p4" class="font-14 grey-color font-weight-400 zero-padding">
            Billing Address: {{billingAddress ? billingAddress : 'Not configured'}}
          </p>
        </div> -->
      </div>
      <button mat-flat-button class="button" (click)="onUpdatePaymentMethodClicked()"
        [disabled]="stolenStatus">Edit</button>
    </div>

    <!-- Subscription contact information -->
    <div class="container-detail">
      <div>
        <p class="font-14 black-color font-weight-500 padding-top-10">
          Subscriber Contact Information
        </p>
      </div>
      <button mat-flat-button class="button" (click)="onEditSubscriptionInfo()" [disabled]="stolenStatus">
        Edit
      </button>
    </div>
    <div class="row">
      <div class="col-sm-3">
        <p class="font-14 black-color font-weight-400">Name</p>
        <p class="font-14 grey-color font-weight-400">
          {{ acctDetail && acctDetail.firstName + " " + acctDetail.lastName }}
        </p>
      </div>
      <div class="col-sm-3">
        <p class="font-14 black-color font-weight-400">Primary Phone Number</p>
        <p class="font-14 grey-color font-weight-400">
          {{ primaryPhoneNumber }}
        </p>
      </div>
      <div class="col-sm-3">
        <p class="font-14 black-color font-weight-400">Email</p>
        <p class="font-14 grey-color font-weight-400 break-word"> {{ acctDetail && acctDetail.email }}</p>
      </div>
      <div class="col-sm-3">
        <p class="font-14 black-color font-weight-400">Preferred Language</p>
        <p class="font-14 grey-color font-weight-400">{{prefLanguage}}</p>
      </div>
      <div class="col-sm-3">
        <p class="font-14 black-color font-weight-400">Address</p>
        <p class="font-14 grey-color font-weight-400">
          {{ street }}
        </p>
        <p class="font-14 grey-color font-weight-400">
          {{ city }}
        </p>
        <p class="font-14 grey-color font-weight-400">
          {{ country }}
        </p>
      </div>
      <div class="col-sm-3">
        <p class="font-14 black-color font-weight-400">
          Secondary Phone Number
        </p>
        <p class="font-14 grey-color font-weight-400"> {{ cellPhoneNumber }}</p>
      </div>
      <div class="col-sm-6"></div>
    </div>
    <!--Connected Garage Features -->
    <div class="container-detail">
      <div>
        <p class="font-14 black-color font-weight-500">
          myQ Connected Garage Features
        </p>
      </div>
      <button mat-flat-button class="button" (click)="onViewmyQConnectedGarageFeatureClick()">
        View
      </button>
    </div>

    <!-- Introduction Video -->
    <div class="container-detail">
      <div>
        <p class="font-14 black-color font-weight-500 padding-top-10">
          myQ Connected Garage - Introduction Video
        </p>
      </div>
      <button mat-flat-button class="button" (click)="onViewmyQConnectedGarageDemoClick()">
        View
      </button>
    </div>

    <!-- Terms of Use -->
    <div class="container-detail">
      <div>
        <p id="p1" class="font-14 black-color font-weight-500">
          myQ Connected Garage - Terms of Use
        </p>
        <p id="p2" class="font-12 grey-color font-weight-400">
          Last Updated:
          <span *ngIf="currentPlanStatus === 'Active'">{{currentPlanInfo.startDate | date: 'MM/dd/yyyy' }}</span>
          <span *ngIf="currentPlanStatus !== 'Active'">{{selectedSP.planDate | date: 'MM/dd/yyyy' }}</span>
        </p>
      </div>
      <button mat-flat-button class="button" (click)="onViewTermsOfServiceClick()" [disabled]="stolenStatus">
        View
      </button>
    </div>

    <!-- Cancel Subscription -->
    <div *ngIf="currentPlanStatus === 'Active' " class="container-detail">
      <div>
        <p class="font-14 black-color font-weight-500">Cancel Subscription</p>
      </div>
      <button mat-flat-button class="button" (click)="onCancelSubscriptionClicked()" [disabled]="stolenStatus">
        Cancel
      </button>
    </div>
    <div *ngIf="currentPlanStatus === 'Active' && allowCancelOrChangeSubscription">
      <p class="font-14 text-center-align grey-color font-weight-400">
        You also may cancel your subscription by calling us at +1 (888) 528-7876
      </p>
    </div>

    <!-- Features Section end-->

  </div>
</div>